import { Component, OnInit, Input } from '@angular/core';

export interface ILegendItem {
  icon: string;
  label?: string;
}

export interface IDomain {
  min: any;
  max: any;
}

@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss']
})
export class LegendComponent implements OnInit {
  @Input() title: string;
  @Input() type: string; // 'enum' || 'ramp'
  @Input() legend: ILegendItem[];
  @Input() domain: IDomain;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/map/legend/legend.component.ts